import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { ProfileService } from '@services/profile/profile.service';
import { transformToNumber } from '@shared/utils/format-number';
/**
 * Pipe that formats the number values. It is mainly used in the `Input` component supported by `UI Studio` tool.
 *
 * This class should not be modified.
 */
@Pipe({
  name: 'numberPipe'
})
export class NumberPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe, private profile: ProfileService) { }
  /**
   * Formats the provided value using native Angular Pipe
   * @param value
   * @param fractionSize
   */
  transform(value: number | string, fractionSize?: number): string {
    const numberValue = transformToNumber(value, this.profile.getGroupingSymbol(), this.profile.getDecimalSymbol());
    return this.decimalPipe.transform(numberValue, "1.2-20", this.profile.getLocale());
  }
  transformNoDecimal(value: number | string, fractionSize?: number): string {
    const numberValue = transformToNumber(value, this.profile.getGroupingSymbol(), this.profile.getDecimalSymbol());
    return this.decimalPipe.transform(numberValue, "1.0-0", this.profile.getLocale());
  }
}